import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';
import { GroupsApi } from '@api/groups/groups.api';
import { chain, isEqual } from 'lodash';
import { merge, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
var LinkGroupsComponent = /** @class */ (function () {
    function LinkGroupsComponent(linkedGroups, groupsApi, fb) {
        this.linkedGroups = linkedGroups;
        this.groupsApi = groupsApi;
        this.fb = fb;
        this.destroyed$ = new Subject();
        this.groupsPagedResult = {};
        this.isLoadingGroups = true;
        this.groupsToAdd = new FormArray([]);
        this.searchGroupsInput = new FormControl();
    }
    LinkGroupsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.filterGroups(true)];
                    case 1:
                        _a.sent();
                        merge(this.searchGroupsInput.valueChanges)
                            .pipe(debounceTime(500), takeUntil(this.destroyed$))
                            .subscribe(function () { return _this.filterGroups(true); });
                        return [2 /*return*/];
                }
            });
        });
    };
    LinkGroupsComponent.prototype.ngOnDestroy = function () {
        this.destroyed$.next();
        this.destroyed$.complete();
    };
    LinkGroupsComponent.prototype.isLinkedGroup = function (groupId) {
        return this.linkedGroups.map(function (group) { return group.id; }).includes(groupId);
    };
    LinkGroupsComponent.prototype.isAddedGroup = function (groupId) {
        return this.groupsToAdd.value.map(function (group) { return group.id; }).includes(groupId);
    };
    LinkGroupsComponent.prototype.selectOrDeselectAllGroups = function (select) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, group, isLinked, isAdded, isAddGroups, isRemoveGroups;
            var e_1, _c;
            return tslib_1.__generator(this, function (_d) {
                try {
                    for (_a = tslib_1.__values(this.groupsPagedResult.items), _b = _a.next(); !_b.done; _b = _a.next()) {
                        group = _b.value;
                        isLinked = this.isLinkedGroup(group.id);
                        isAdded = this.isAddedGroup(group.id);
                        isAddGroups = select && isAdded;
                        isRemoveGroups = !select && !isAdded;
                        if (isLinked || isAddGroups || isRemoveGroups) {
                            continue;
                        }
                        this.addOrRemoveGroup(group);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return [2 /*return*/];
            });
        });
    };
    LinkGroupsComponent.prototype.addOrRemoveGroup = function (group) {
        var filteredGroupIndex = this.groupsToAdd.value.findIndex(function (formGroup) { return formGroup.id === group.id; });
        if (filteredGroupIndex >= 0) {
            this.groupsToAdd.removeAt(filteredGroupIndex);
            this.setIsAllChecked();
            return;
        }
        this.groupsToAdd.setControl(this.groupsToAdd.value.length, this.fb.group(group));
        this.setIsAllChecked();
    };
    LinkGroupsComponent.prototype.setDefaultPaginate = function () {
        this.lastPaginatedGroupIndex = 5;
        this.firstPaginatedGroupIndex = 1;
    };
    LinkGroupsComponent.prototype.filterGroups = function (resetPaginate) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payload, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoadingGroups = true;
                        if (resetPaginate) {
                            this.setDefaultPaginate();
                        }
                        payload = {
                            query: {
                                name_or_description_contains: this.searchGroupsInput.value
                            },
                            options: {
                                offset: this.firstPaginatedGroupIndex - 1,
                                limit: 5,
                                orderColumn: 'name',
                                order: 'asc'
                            }
                        };
                        _a = this;
                        return [4 /*yield*/, this.groupsApi.search(payload.query, payload.options).toPromise()];
                    case 1:
                        _a.groupsPagedResult = _b.sent();
                        this.isLoadingGroups = false;
                        this.setIsAllChecked();
                        this.form.nativeElement.scrollTo({ top: 0 });
                        return [2 /*return*/];
                }
            });
        });
    };
    LinkGroupsComponent.prototype.changePage = function (next) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (next) {
                            this.lastPaginatedGroupIndex += 5;
                            this.firstPaginatedGroupIndex += 5;
                        }
                        else {
                            this.lastPaginatedGroupIndex -= 5;
                            this.firstPaginatedGroupIndex -= 5;
                        }
                        return [4 /*yield*/, this.filterGroups()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LinkGroupsComponent.prototype.setIsAllChecked = function () {
        var _this = this;
        var unlinkedGroups = chain(this.groupsPagedResult.items)
            .filter(function (group) { return !_this.isLinkedGroup(group.id); })
            .sortBy('name')
            .value();
        var linkedGroups = chain(this.groupsPagedResult.items)
            .filter(function (group) { return _this.isLinkedGroup(group.id); })
            .sortBy('name')
            .value()
            .length;
        var addedGroups = chain(this.groupsPagedResult.items)
            .filter(function (group) { return _this.isAddedGroup(group.id); })
            .sortBy('name')
            .value();
        this.isAllLinked = linkedGroups === 5 || linkedGroups === this.groupsPagedResult.totalCount;
        this.isAllSelected = !this.isAllLinked && isEqual(unlinkedGroups, addedGroups);
    };
    return LinkGroupsComponent;
}());
export { LinkGroupsComponent };
